var $ = global.jQuery = global.$;
var _Base = require('./_Base');
var pca = require('../services/pca');
var _debounce = require('lodash/function/debounce');

var matchesTpl = require('../templates/fuzzyMatches.dot');
/**
 * Address lookup field
 * @class
 * @extends _Base
 */
var Address = _Base.extend(
  /** @lends Address.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;
    var debouncedOnFieldUpdated = _debounce(this.onFieldUpdated, 300);
    this.$matches = this.$el.find('[data-address-matches]');
    this.waitover = false;
    this.$input = this.$el.find('input').eq(0);
    this.$el.on('Field:Updated', debouncedOnFieldUpdated.bind(this));
    this.$input.on('focusin', function(){
      self.$matches.show();
    });
    $(document).on('click focusin', function(event) {
      if (!$(event.target).closest(self.$el).length) {
        self.$matches.hide();
      }
    });
  },
  onFieldUpdated: function(event, name, value) {
    if (value.length) this.updateResults(value);
  },
  updateResults: function(searchTerm, lastId) {
    var self = this;
    this.currentTerm = searchTerm;
    pca.findAddress(searchTerm, lastId)
      .done(function(response) {
        if (response.Items && response.Items.length) {
          self.buildMatches(response.Items);
        }
      });
  },
  buildMatches: function(matches) {
    var self = this,
        $html = $(matchesTpl(matches)),
        $item = $html.find('[data-action]');

    $item.on('click', function(event) {
      event.preventDefault();
      var $this = $(this),
          action = $this.data('action'),
          lastId = $this.data('id'),
          itemText = $this.data('text'),
          searchTerm = lastId === 'GBR|' ? itemText : self.currentTerm;

      lastId = lastId && lastId !== 'GBR|' ? lastId : '';

      if (action === 'Find') {
        self.updateResults(searchTerm, lastId);
      } else if (action === 'Retrieve'){
        self.getAddressDetails(lastId);
        self.$matches.hide();
      }
    });
    this.$matches.html($html);
  },
  getAddressDetails: function(id) {
    var self = this;
    pca.lookupAddressById(id)
      .done(function(response) {
        self.updateAddress(response.Items[0]);
      });
  },
  updateAddress: function(details) {
    var address = {};
    var companyName = details.Company !== '' ? details.Company : false;
    var address1 = details.Line1;
    var address2 = details.Line2;
    if (details.Line3 !== '') address2 += ', ' + details.Line3;
    if (details.Line4 !== '') address2 += ', ' + details.Line4;
    if (details.Line5 !== '') address2 += ', ' + details.Line5;
    if (companyName) {
      address2 = address1 + (address2 !== '' ? ', ' + address2 : '');
      address1 = companyName;
    }
    address.Address1 = address1.trim();
    address.Address2 = address2.trim();
    address.PostCode = details.PostalCode;
    address.City = details.City;

    this.$el.trigger('Address:Updated',[address]);
  }
});

module.exports = Address;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Address.js
// module id = 15
// module chunks = 0